var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrows({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00008 11.3334C4.00008 11.3334 1.64008 8.93335 0.860081 8.13335C0.733415 8.00669 0.666748 7.83335 0.666748 7.66669C0.666748 7.30002 0.966748 7.00002 1.33341 7.00002C1.50675 7.00002 1.68008 7.06669 1.80675 7.20002C2.35341 7.76002 4.00008 9.42669 4.00008 9.42669C4.00008 9.42669 5.64008 7.75335 6.19341 7.20002C6.32675 7.06669 6.49341 7.00002 6.66675 7.00002C7.03341 7.00002 7.33341 7.30002 7.33341 7.66669C7.33341 7.83335 7.26675 8.00669 7.14008 8.13335C6.35341 8.93335 4.00008 11.3334 4.00008 11.3334ZM7.33341 4.33335C7.33341 4.16669 7.26675 3.99335 7.14008 3.86669C6.35341 3.06669 4.00008 0.666687 4.00008 0.666687C4.00008 0.666687 1.64008 3.06669 0.860081 3.86669C0.733415 3.99335 0.666748 4.16669 0.666748 4.33335C0.666748 4.70002 0.966748 5.00002 1.33341 5.00002C1.50675 5.00002 1.68008 4.93335 1.80675 4.80002C2.35341 4.24002 4.00008 2.57335 4.00008 2.57335C4.00008 2.57335 5.64008 4.24669 6.19341 4.80002C6.32675 4.93335 6.49341 5.00002 6.66675 5.00002C7.03341 5.00002 7.33341 4.70002 7.33341 4.33335Z",
    fill: "#ADB8E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.b89468025f50dc7e7e81c123efe01731.svg";
export { ForwardRef as ReactComponent };